/* eslint-disable camelcase */
import { BeneficiosPage } from '@pages/Beneficios';
import { Beneficiarios } from '@pages/Beneficios/components/Beneficiarios';
import { Renda } from '@pages/Beneficios/components/Renda';
import { Resultado } from '@pages/Beneficios/components/Resultado';
import { EmprestimosPage } from '@pages/Emprestimos';
import { Calendario } from '@pages/Emprestimos/Calendario';
import { SaibaMaisEmprestimoConscientePage } from '@pages/Emprestimos/EmprestimoConsciente';
import { FaleComSetorEmprestimoPage } from '@pages/Emprestimos/FaleComSetorEmprestimo';
import { RegrasGeraisEmprestimoPage } from '@pages/Emprestimos/RegrasGerais';
import { RegulamentoEmprestimoPage } from '@pages/Emprestimos/Regulamento';
import { TireSuasDuvidasPage } from '@pages/Emprestimos/TireSuasDuvidas';
import { ContratosAbertos } from '@pages/Emprestimos/components/contratos';
import { Amortizacao } from '@pages/Emprestimos/components/contratos/contrato/Amortizacao';
import { Antecipacao } from '@pages/Emprestimos/components/contratos/contrato/Antecipacao';
import { Carencia } from '@pages/Emprestimos/components/contratos/contrato/Carencia';
import { Prestacoes } from '@pages/Emprestimos/components/contratos/contrato/Prestacoes';
import { Quitacao } from '@pages/Emprestimos/components/contratos/contrato/Quitacao';
import { SimularContratar } from '@pages/Emprestimos/components/simular-contratar';
import { HomePage } from '@pages/Home';
import { LoginPage } from '@pages/Login';
import { MeusDadosPage } from '@pages/MeusDados';
import { OutrasInformacoesPage } from '@pages/OutrasInformacoes';
import { PercentualContribuicaoPage } from '@pages/OutrasInformacoes/Contribuicoes';
import { AlterarPercentualContribuicao } from '@pages/OutrasInformacoes/Contribuicoes/alterarPercentualContribuicao';
import { HistoricoIntencaoMudancaPercentualContribuicao } from '@pages/OutrasInformacoes/Contribuicoes/historico/intencaoMudancaPercentualContribuicao';
import { HistoricoMudancaPercentualContribuicao } from '@pages/OutrasInformacoes/Contribuicoes/historico/mudancaPercentualContribuicao';
import { ConversaoBeneficiosPage } from '@pages/OutrasInformacoes/ConversaoBeneficios';
import { RendaConversaoBeneficios } from '@pages/OutrasInformacoes/ConversaoBeneficios/Renda';
import { EmissaoBoletoVoluntarioPage } from '@pages/OutrasInformacoes/EmissaoBoletoVoluntario';
import { PercentualRecebimentoRendaMensalPage } from '@pages/OutrasInformacoes/RecebimentoRenda/PercentualRecebimentoRenda';
import { SaqueAVistaPage } from '@pages/OutrasInformacoes/SaqueAVista';
import { TransformacaoBeneficiosPage } from '@pages/OutrasInformacoes/TransformacaoBeneficio';
import { TransparenciaPage } from '@pages/OutrasInformacoes/Transparencia';
import { PersonalizacaoHomePage } from '@pages/PersonalizarHome';
import { PlanoBPage } from '@pages/PlanoB';
import { ExtratoPage } from '@pages/PlanoB/Extrato';
import { InformeRendimentosPage } from '@pages/PlanoB/InformeRendimento';
import { ValorBeneficioPage } from '@pages/PlanoB/ValorBeneficio';
import { ContrachequePage } from '@pages/PlanoB/funcionalidades/Contracheque';
import { ExtratoContaAposentadoriaPage } from '@pages/PlanoB/funcionalidades/ExtratoAposentadoria';
import { ExtratoSaldoContaPage } from '@pages/PlanoB/funcionalidades/ExtratoSaldoContas';
import { MemoriaCalculoBeneficioPage } from '@pages/PlanoB/funcionalidades/MemoriaCalculoBeneficios';
import { PerfilInvestimentoPage } from '@pages/PlanoB/perfilInvestimento';
import { HistoricoIntencaoMudancaPerfil } from '@pages/PlanoB/perfilInvestimento/historico/intencaoMudanca';
import { HistoricoMudancaPerfil } from '@pages/PlanoB/perfilInvestimento/historico/mudancaPerfil';
import { PerfilInvestimentoAtual } from '@pages/PlanoB/perfilInvestimento/perfilAtual';
import { PerfilQuestionario } from '@pages/PlanoB/perfilInvestimento/questionario';
import { RecuperarSenhaPage } from '@pages/RecuperarSenha';
import { RequerimentosPage } from '@pages/Requerimentos';
import { AuthProvider, RequireAuth, Shell, useAuth } from '@pages/Shell';
import { SimularUsuarioPage } from '@pages/Simulacao';
import { StyleguidePage } from '@pages/Styleguide';
import { TourProvider } from '@reactour/tour';
import { paths, steps } from '@utils';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet, Route, Routes } from 'react-router-dom';
import { ParcelaAtraso } from '@pages/Emprestimos/components/contratos/contrato/ParcelaAtraso';
import { Simular } from '../pages/Emprestimos/components/simular-contratar/Simular';
import { ResultadoConversaoBeneficio } from '../pages/OutrasInformacoes/ConversaoBeneficios/Resultado';
// import { ResultadoEmprestimo } from '../pages/Emprestimos/components/simular-contratar/Resultado';
import { SaibaMaisSaudeFinanceiraPage } from '../common/components/CardsHome/SaudeFinanceira/saibaMais';
import { ImpostoDeRendaPage } from '../pages/Emprestimos/ImpostoDeRenda';
import { Confirmacao } from '../pages/Emprestimos/components/simular-contratar/Confirmacao';
import { Solicitacao } from '../pages/Emprestimos/components/simular-contratar/Solicitacao';
import { ComunicacaoPlanoPage } from '../pages/OutrasInformacoes/ComunicacaoPlano';
import { CusteioAdminsitrativoPage } from '../pages/OutrasInformacoes/CusteioAdministrativo';
import { OpcaoInstitutoPage } from '../pages/OutrasInformacoes/OpcaoInstituto';
// import { ParcelaAdicionalPage } from '../pages/OutrasInformacoes/ParcelaAdicional';
import { PercentualRecebimentoRendaPage } from '../pages/OutrasInformacoes/RecebimentoRenda';
import { HistoricoRecebimentoRendaPage } from '../pages/OutrasInformacoes/RecebimentoRenda/HistoricoRecebimentoRenda';
import { ReservaMatematicaPage } from '../pages/OutrasInformacoes/ReservaMatematica';
import { TabelaContribuicaoPage } from '../pages/OutrasInformacoes/TabelaContribuicao';
import { SegundaViaBoletoPage } from '../pages/PlanoB/SegundaViaBoleto';
// import { FormTransformacaoPlanoAPage } from '../pages/OutrasInformacoes/TransformacaoBeneficioPlanoA/Solicitacao';
// import { FormSuccessTransformacaoPlanoAPage } from '../pages/OutrasInformacoes/TransformacaoBeneficioPlanoA/Solicitacao/FormSuccess';
// import { SimulacaoTransformacaoPlanoAPage } from '../pages/OutrasInformacoes/TransformacaoBeneficioPlanoA/Simulacao';
import { CalculadoraExaurimentoPage } from '../pages/OutrasInformacoes/CalculadoraExaurimento';
import { SimulacaoResgateParcialPage } from '../pages/OutrasInformacoes/ResgateParcial/Simulacao';
import { SolicitacaoResgateParcialPage } from '../pages/OutrasInformacoes/ResgateParcial/Solicitacao';

import { SolicitacaoFormularioResgateParcialPage } from '../pages/OutrasInformacoes/ResgateParcial/Solicitacao/Form';
import { HistoricoResgateParcial } from '../pages/OutrasInformacoes/ResgateParcial/Solicitacao/History';
import { AbonoAnualPage } from '../pages/PlanoB/funcionalidades/AbonoAnual';
import { SolicitacaoSucessoPage } from '../pages/SucessoSolicitacao';
import { InformeRendimentosResgateParcialPage } from '../pages/OutrasInformacoes/ResgateParcial/InformeRendimento';
import { ExtratoAposentadoriaPensionistaAssistidoPage } from '../pages/PlanoB/funcionalidades/ExtratoAposentadoriaPensionistaAssistido';
import { ParcelaAdicionalPage } from '../pages/OutrasInformacoes/ParcelaAdicional';

const disableBody = (target) => disableBodyScroll(target);
const enableBody = (target) => enableBodyScroll(target);

const Router = () => {
  const {
    extrato_conta_ativo,
    extrato_aposentadoria,
    percentual_contribuicao,
    aporte,
    simular_beneficio,
    contracheque,
    informe_rendimento,
    abono_anual,
    simular_emprestimo,
    contratos_aberto,
    cpa,
    extrato_cnpc,
    questionario_investidor,
    historico_perfil,
    memoria_calculo,
    parcela_adicional,
    saque_vista,
    simular_conversao_beneficio,
    transformacao_reserva,
    tabela_contribuicao,
    reserva_matematica,
    comunicacao_plano,
    extrato_opcao,
    alterar_recebimento,
    segunda_via_boleto,
    resgate_parcial,
    extrato_pensionista_assistido,
  } = useSelector((state) => state.telasDisponiveis);

  return (
    <AuthProvider>
      <TourProvider
        styles={{
          popover: (base) => ({
            ...base,
            '--reactour-accent': '#e87400',
            borderRadius: 10,
          }),
        }}
        badgeContent={({ totalSteps, currentStep }) =>
          `${currentStep + 1}/${totalSteps}`
        }
        afterOpen={disableBody}
        beforeClose={enableBody}
        steps={steps}
      >
        <Routes>
          <Route element={<Layout />}>
            <Route
              path="*"
              element={
                <RequireAuth>
                  <HomePage />
                </RequireAuth>
              }
            />

            <Route
              path={paths.HOME}
              element={
                <RequireAuth>
                  <HomePage />
                </RequireAuth>
              }
            />
            <Route
              path={paths.OUTRAS_INFOS}
              element={
                <RequireAuth>
                  <OutrasInformacoesPage />
                </RequireAuth>
              }
            />
            <Route
              path={paths.MEUS_DADOS}
              element={
                <RequireAuth modalPendencias={false}>
                  <MeusDadosPage />
                </RequireAuth>
              }
            />
            {simular_conversao_beneficio && (
              <Route
                path={paths.CONVERSAO_BENEFICIOS}
                element={
                  <RequireAuth>
                    <ConversaoBeneficiosPage />
                  </RequireAuth>
                }
              >
                <Route index element={<RendaConversaoBeneficios />} />
                <Route
                  path={paths.BENEFICIARIOS_CONVERSAO}
                  element={<Beneficiarios />}
                />
                <Route
                  path={paths.RESULTADO_CONVERSAO}
                  element={<ResultadoConversaoBeneficio />}
                />
              </Route>
            )}

            {(cpa ||
              transformacao_reserva ||
              saque_vista ||
              reserva_matematica ||
              alterar_recebimento ||
              parcela_adicional ||
              memoria_calculo ||
              informe_rendimento ||
              simular_conversao_beneficio ||
              contracheque ||
              simular_beneficio) && (
              <Route
                path={paths.BENEFICIOS}
                element={
                  <RequireAuth>
                    <BeneficiosPage />
                  </RequireAuth>
                }
              >
                {simular_beneficio && (
                  <>
                    <Route index element={<Renda />} />
                    <Route
                      path={paths.RESULTADO_BENEFICIOS}
                      element={<Resultado />}
                    />
                    <Route
                      path={paths.BENEFICIARIOS}
                      element={<Beneficiarios />}
                    />
                  </>
                )}
              </Route>
            )}

            <Route
              path={paths.PLANO_B}
              element={
                <RequireAuth>
                  <PlanoBPage />
                </RequireAuth>
              }
            />

            {(simular_emprestimo || contratos_aberto) && (
              <Route
                path={paths.EMPRESTIMOS}
                element={
                  <RequireAuth>
                    <EmprestimosPage />
                  </RequireAuth>
                }
              >
                {simular_emprestimo && (
                  <Route path={paths.SIMULADOR} element={<SimularContratar />}>
                    <Route index element={<Simular />} />
                    {/* <Route path="resultado" element={<ResultadoEmprestimo />} /> */}
                    <Route path={paths.SOLICITACAO} element={<Solicitacao />} />
                    <Route path={paths.CONFIRMACAO} element={<Confirmacao />} />
                  </Route>
                )}
                {contratos_aberto && (
                  <Route path={paths.CONTRATOS} element={<ContratosAbertos />}>
                    <Route path=":id/quitacao" element={<Quitacao />} />
                    <Route path=":id/antecipar" element={<Antecipacao />} />
                    <Route path=":id/amortizar" element={<Amortizacao />} />
                    <Route path=":id/prestacoes" element={<Prestacoes />} />
                    <Route path=":id/carencia" element={<Carencia />} />
                    <Route
                      path=":id/parcelaAtraso"
                      element={<ParcelaAtraso />}
                    />
                  </Route>
                )}
              </Route>
            )}

            <Route
              path={paths.REQUERIMENTOS}
              element={
                <RequireAuth>
                  <RequerimentosPage />
                </RequireAuth>
              }
            />

            <Route
              path={paths.PERSONALIZACAO}
              element={
                <RequireAuth>
                  <PersonalizacaoHomePage />
                </RequireAuth>
              }
            />
            <Route
              path={paths.SIMULAR_USUARIO}
              x
              element={<SimularUsuarioPage />}
            />
            <Route
              path={paths.SIMULAR_USUARIO_PORTAL}
              element={
                <RequireAuth>
                  <SimularUsuarioPage />
                </RequireAuth>
              }
            />
            {parcela_adicional && (
              <Route
                path={paths.PARCELA_ADICIONAL}
                element={
                  <RequireAuth>
                    <ParcelaAdicionalPage />
                  </RequireAuth>
                }
              />
            )}

            {/* <Route
              path={paths.FORM_TRANSFORMACAO_PLA}
              element={
                <RequireAuth>
                  <FormTransformacaoPlanoAPage />
                </RequireAuth>
              }
            />
            <Route
              path={paths.SIMULACAO_TRANSFORMACAO_PLA}
              element={
                <RequireAuth>
                  <SimulacaoTransformacaoPlanoAPage />
                </RequireAuth>
              }
            />

            <Route
              path={paths.FORM_TRANSFORMACAO_PLA_SUCCESS}
              element={
                <RequireAuth>
                  <FormSuccessTransformacaoPlanoAPage />
                </RequireAuth>
              }
            /> */}
            {resgate_parcial && (
              <>
                <Route
                  path={paths.SIMULADOR_RESGATE_PARCIAL}
                  element={
                    <RequireAuth>
                      <SimulacaoResgateParcialPage />
                    </RequireAuth>
                  }
                />
                <Route
                  path={paths.SOLICITACAO_RESGATE_PARCIAL}
                  element={
                    <RequireAuth>
                      <SolicitacaoResgateParcialPage />
                    </RequireAuth>
                  }
                >
                  <Route
                    path={paths.SOLICITACAO_RESGATE_PARCIAL_FORMULARIO}
                    element={
                      <RequireAuth>
                        <SolicitacaoFormularioResgateParcialPage />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path={paths.SOLICITACAO_RESGATE_PARCIAL_HISTORICO}
                    element={
                      <RequireAuth>
                        <HistoricoResgateParcial />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path={paths.SOLICITACAO_RESGATE_PARCIAL_INFORME}
                    element={
                      <RequireAuth>
                        <InformeRendimentosResgateParcialPage />
                      </RequireAuth>
                    }
                  />
                </Route>
              </>
            )}

            <Route
              path={paths.EXTRATO_APOSENTADORIA}
              element={
                <RequireAuth>
                  <ExtratoContaAposentadoriaPage />
                </RequireAuth>
              }
            />
            {(extrato_conta_ativo || extrato_aposentadoria) && (
              <Route
                path={paths.EXTRADO_SALDO_CONTAS}
                element={
                  <RequireAuth>
                    <ExtratoSaldoContaPage />
                  </RequireAuth>
                }
              />
            )}

            {extrato_pensionista_assistido && (
              <Route
                path={paths.EXTRADO_SALDO_CONTAS_ASSISTIDO_PENSIONISTA}
                element={
                  <RequireAuth>
                    <ExtratoAposentadoriaPensionistaAssistidoPage />
                  </RequireAuth>
                }
              />
            )}

            {contracheque && (
              <Route
                path={paths.CONTRACHEQUE}
                element={
                  <RequireAuth>
                    <ContrachequePage />
                  </RequireAuth>
                }
              />
            )}

            {alterar_recebimento && (
              <Route
                path={paths.PERCENTUAL_RENDA_INICIAL}
                element={
                  <RequireAuth>
                    <PercentualRecebimentoRendaPage />
                  </RequireAuth>
                }
              >
                <Route
                  path={paths.PERCENTUAL_RENDA_MENSAL_ABSOLUTE_PATH}
                  element={<PercentualRecebimentoRendaMensalPage />}
                />

                <Route
                  path={paths.HISTORICO_RENDA_MENSAL_ABSOLUTE_PATH}
                  element={<HistoricoRecebimentoRendaPage />}
                />
              </Route>
            )}

            {informe_rendimento && (
              <Route
                path={paths.INFORME_RENDIMENTOS}
                element={
                  <RequireAuth>
                    <InformeRendimentosPage />
                  </RequireAuth>
                }
              />
            )}

            {abono_anual && (
              <Route
                path={paths.ABONO_ANUAL}
                element={
                  <RequireAuth>
                    <AbonoAnualPage urlGetPDF="ObterContrachequeAdiantamentoAbonoAnual" />
                  </RequireAuth>
                }
              />
            )}

            {memoria_calculo && (
              <Route
                path={paths.MEMORIA_CALCULO}
                element={
                  <RequireAuth>
                    <MemoriaCalculoBeneficioPage />
                  </RequireAuth>
                }
              />
            )}

            <Route
              path={paths.EMPRESTIMO_CONSCIENTE}
              element={
                <RequireAuth>
                  <SaibaMaisEmprestimoConscientePage />
                </RequireAuth>
              }
            />

            <Route
              path={paths.IMPOSTO_DE_RENDA}
              element={
                <RequireAuth>
                  <ImpostoDeRendaPage />
                </RequireAuth>
              }
            />

            <Route
              path={paths.PERFIL_INVESTIMENTO}
              element={
                <RequireAuth>
                  <PerfilInvestimentoPage />
                </RequireAuth>
              }
            >
              <Route
                path={paths.TROCA_DE_PERFIL}
                element={<PerfilInvestimentoAtual />}
              />

              {questionario_investidor && (
                <Route
                  path={paths.QUESTIONARIO}
                  element={<PerfilQuestionario />}
                />
              )}
              {historico_perfil && (
                <>
                  <Route
                    path={paths.INTENCAO_MUDANCA_PERFIL}
                    element={<HistoricoIntencaoMudancaPerfil />}
                  />
                  <Route
                    path={paths.MUDANCA_PERFIL}
                    element={<HistoricoMudancaPerfil />}
                  />
                </>
              )}
            </Route>
            <Route
              path={paths.PERCENTUAL_CONTRIBUICAO}
              element={
                <RequireAuth>
                  <PercentualContribuicaoPage />
                </RequireAuth>
              }
            >
              {percentual_contribuicao && (
                <Route
                  path={paths.ALTERAR_PC}
                  element={<AlterarPercentualContribuicao />}
                  index
                />
              )}

              <Route
                path={paths.INTENCAO_MUDANCA_PC}
                element={<HistoricoIntencaoMudancaPercentualContribuicao />}
              />
              <Route
                path={paths.MUDANCA_PC}
                element={<HistoricoMudancaPercentualContribuicao />}
              />
            </Route>

            {aporte && (
              <Route
                path={paths.EMISSAO_BOLETO_VOLUNTARIO}
                element={
                  <RequireAuth>
                    <EmissaoBoletoVoluntarioPage />
                  </RequireAuth>
                }
              />
            )}

            <Route
              path={paths.REGULAMENTO_EMPRESTIMO}
              element={
                <RequireAuth>
                  <RegulamentoEmprestimoPage />
                </RequireAuth>
              }
            />
            <Route
              path={paths.REGRAS_GERAIS_EMPRESTIMO}
              element={
                <RequireAuth>
                  <RegrasGeraisEmprestimoPage />
                </RequireAuth>
              }
            />
            <Route
              path={paths.TIRA_DUVIDAS}
              element={
                <RequireAuth>
                  <TireSuasDuvidasPage />
                </RequireAuth>
              }
            />
            <Route
              path={paths.CONTATO_EMPRESTIMO}
              element={
                <RequireAuth>
                  <FaleComSetorEmprestimoPage />
                </RequireAuth>
              }
            />

            {extrato_cnpc && (
              <Route
                path={paths.EXTRATO_PARTICIPANTE}
                element={
                  <RequireAuth>
                    <ExtratoPage />
                  </RequireAuth>
                }
              />
            )}

            {cpa && (
              <Route
                path={paths.VALOR_BENEFICIO}
                element={
                  <RequireAuth>
                    <ValorBeneficioPage />
                  </RequireAuth>
                }
              />
            )}

            {saque_vista && (
              <Route
                path={paths.SAQUE_VISTA}
                element={
                  <RequireAuth>
                    <SaqueAVistaPage />
                  </RequireAuth>
                }
              />
            )}

            {tabela_contribuicao && (
              <Route
                path={paths.TABELA_CONTRIBUICAO}
                element={
                  <RequireAuth>
                    <TabelaContribuicaoPage />
                  </RequireAuth>
                }
              />
            )}

            {transformacao_reserva && (
              <Route
                path={paths.TRANSFORMACAO_BENEFICIO}
                element={
                  <RequireAuth>
                    <TransformacaoBeneficiosPage />
                  </RequireAuth>
                }
              />
            )}

            <Route
              path={paths.CALCULADORA_EXAURIMENTO}
              element={
                <RequireAuth>
                  <CalculadoraExaurimentoPage />
                </RequireAuth>
              }
            />

            {reserva_matematica && (
              <Route
                path={paths.RESERVA_MATEMATICA}
                element={
                  <RequireAuth>
                    <ReservaMatematicaPage />
                  </RequireAuth>
                }
              />
            )}

            {comunicacao_plano && (
              <Route
                path={paths.COMUNICACAO_PLANO}
                element={
                  <RequireAuth>
                    <ComunicacaoPlanoPage />
                  </RequireAuth>
                }
              />
            )}

            {extrato_opcao && (
              <Route
                path={paths.OPCAO_INSTITUTO}
                element={
                  <RequireAuth>
                    <OpcaoInstitutoPage />
                  </RequireAuth>
                }
              />
            )}

            <Route
              path={paths.CUSTEIO_ADMINISTRATIVO}
              element={
                <RequireAuth>
                  <CusteioAdminsitrativoPage />
                </RequireAuth>
              }
            />

            {alterar_recebimento && (
              <Route
                path={paths.HISTORICO_TROCA_RECEBIMENTO_RENDA}
                element={
                  <RequireAuth>
                    <HistoricoIntencaoMudancaPercentualContribuicao />
                  </RequireAuth>
                }
              />
            )}

            {segunda_via_boleto && (
              <Route
                path={paths.SEGUNDA_VIA_BOLETO}
                element={
                  <RequireAuth>
                    <SegundaViaBoletoPage />
                  </RequireAuth>
                }
              />
            )}

            <Route
              path={paths.TRANSPARENCIA}
              element={
                <RequireAuth>
                  <TransparenciaPage />
                </RequireAuth>
              }
            >
              <Route path=":id" element={<TransparenciaPage />} />
            </Route>

            <Route path={paths.LOGIN} element={<LoginPage />} />
            <Route
              path={paths.RECUPERAR_SENHA}
              element={<RecuperarSenhaPage />}
            />

            <Route
              path={paths.PRIMEIRO_ACESSO}
              element={<RecuperarSenhaPage isPA />}
            />

            <Route
              path={paths.SOLICITACAO_SUCESSO}
              element={
                <RequireAuth modalPendencias={false}>
                  <SolicitacaoSucessoPage />
                </RequireAuth>
              }
            />

            <Route
              path={paths.CALENDARIO_EMPRESTIMO}
              element={<Calendario />}
            />
            <Route
              path={paths.SAIBA_MAIS_SAUDE_FINANCEIRA}
              element={<SaibaMaisSaudeFinanceiraPage />}
            />
            <Route path={paths.STYLEGUIDE} element={<StyleguidePage />} />
          </Route>
        </Routes>
      </TourProvider>
    </AuthProvider>
  );
};

export default Router;

const Layout = () => {
  const auth = useAuth();

  if (!auth.user) {
    return <Outlet />;
  }

  return (
    <Shell>
      <Outlet />
    </Shell>
  );
};
